import { render, staticRenderFns } from "./TitulosContaReceber.vue?vue&type=template&id=56a53421"
import script from "./TitulosContaReceber.vue?vue&type=script&lang=js"
export * from "./TitulosContaReceber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports